import PropTypes from 'prop-types';

export default PropTypes.shape({
    id: PropTypes.string,
    fileName: PropTypes.string,
    fileSize: PropTypes.number,
    downloadUrl: PropTypes.string,
    previewState: PropTypes.string,
    previewType: PropTypes.string,
    previewMessage: PropTypes.string,
    previewUrls: PropTypes.shape({
        original: PropTypes.string,
        large: PropTypes.string,
        collaboration: PropTypes.string,
        medium: PropTypes.string,
        small: PropTypes.string,
        thumb: PropTypes.string,
        thumbLarge: PropTypes.string
    }),
    videoUrls: PropTypes.shape({
        mediaUrl: PropTypes.string
    })
});
